// extracted by mini-css-extract-plugin
module.exports = {"img":"img--32E7W"};